import React, { useMemo, useState } from 'react';
import { Autocomplete, TextField, Box, Checkbox, Typography, CircularProgress } from '@mui/material';
import CustomListbox from '../../../components/CustomListbox';

const VatTrnMultiSelect = ({
  options = [],
  selected = [],
  isLoading = false,
  disabled = false,
  onChange,
  label,
  selectAllLabel,
}) => {
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState('');

  const selectedObjects = useMemo(
    () => options.filter((option) => selected.includes(option.vat_number)),
    [options, selected],
  );

  const resolvedSelectAllLabel = (selectAllLabel ?? 'Select all').replace('{count}', String(options.length));

  return (
    <Box>
      <Autocomplete
        multiple
        fullWidth
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        options={options}
        loading={isLoading}
        disabled={disabled || isLoading}
        value={selectedObjects}
        inputValue={inputValue}
        disableCloseOnSelect
        filterOptions={(opts, state) => {
          const query = state.inputValue.trim().toLowerCase();
          if (!query) {
            return opts;
          }
          return opts.filter(
            (option) => option.vat_number?.toLowerCase().includes(query) || option.label?.toLowerCase().includes(query),
          );
        }}
        ListboxComponent={CustomListbox}
        ListboxProps={{
          selectAllLabel: resolvedSelectAllLabel,
          onSelectAll: () => onChange(options.map((option) => option.vat_number)),
          onClearAll: () => onChange([]),
          sx: {
            paddingTop: 0,
            maxHeight: 256,
            overflowY: 'auto',
          },
        }}
        onInputChange={(event, value, reason) => {
          if (reason === 'input') {
            setInputValue(value);
          }
        }}
        getOptionLabel={(option) => option.label || option.vat_number || ''}
        isOptionEqualToValue={(option, value) => option.vat_number === value.vat_number}
        onChange={(_, newValue) => {
          onChange(newValue.map((option) => option.vat_number));
        }}
        renderTags={(value) => {
          if (open) return null;
          return <span style={{ marginLeft: 8 }}>{value.map((option) => option.label).join(', ')}</span>;
        }}
        renderOption={(props, option, { selected: isSelected }) => (
          <li {...props}>
            <Checkbox checked={isSelected} sx={{ marginRight: 1 }} />
            <Typography fontSize={14} fontWeight={500}>
              {option.label}
            </Typography>
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            placeholder={open ? label : ''}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {isLoading ? <CircularProgress color="inherit" size={18} /> : null}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};

export default VatTrnMultiSelect;
